import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileBlurbEditorActions'
import { validiateTextField } from '../../../common/forms/validationFunctions'

const initialState = {
  submitting: false,
  loadingBlurb: false,
  editingBlurb: false,
  beforeEditingState: {},
  isInvalid: {
    formIsValid: true,
    firstName: {
      isInvalid: false,
      message: null
    },
    middleName: {
      isInvalid: false,
      message: null
    },
    lastName: {
      isInvalid: false,
      message: null
    },
    title: {
      isInvalid: false,
      message: null
    },
    company: {
      isInvalid: false, // 'error'
      message: null // msg
    },
    companyWebsite: {
      isInvalid: false,
      message: null
    },
    buildingDetails: {
      isInvalid: false,
      message: null
    },
    streetAddress: {
      isInvalid: false,
      message: null
    },
    suburb: {
      isInvalid: false,
      message: null
    },
    postalCode: {
      isInvalid: false,
      message: null
    },
    city: {
      isInvalid: false,
      message: null
    },
    businessDescription: {
      isInvalid: false,
      message: null
    }
  }
}

export const formIsValid = (isInvalid) => {
  // validiateTextField returns a boolean `isInvalid` (not the legacy BS3 'error' string),
  // so gate on the boolean - otherwise every comparison is always true and required fields
  // never block Save.
  return !isInvalid.title.isInvalid &&
    !isInvalid.company.isInvalid &&
    !isInvalid.companyWebsite.isInvalid &&
    !isInvalid.buildingDetails.isInvalid &&
    !isInvalid.streetAddress.isInvalid &&
    !isInvalid.suburb.isInvalid &&
    !isInvalid.postalCode.isInvalid &&
    !isInvalid.city.isInvalid &&
    !isInvalid.businessDescription.isInvalid &&
    !isInvalid.firstName.isInvalid &&
    !isInvalid.middleName.isInvalid &&
    !isInvalid.lastName.isInvalid
}

export default function (state = initialState, action) {
  function copyBlurbState (state) {
    var blurb = cloneDeep(state.blurb)
    blurb.isInvalid = cloneDeep(state.blurb.isInvalid)
    return blurb
  }

  const { edit, set } = events

  // not going to copy all the state over because we're using reducer composition.
  // just copying the pieces i want to work with
  switch (action.type) {
    case edit.start:
      state.blurb = copyBlurbState(state)
      state.blurb.editingBlurb = true
      state.beforeEditingState = state.profile
      return state
    case edit.stop:
      state.blurb = copyBlurbState(state)
      state.blurb.editingBlurb = false
      return state
    case edit.cancel:
      state.blurb = copyBlurbState(state)
      state.blurb.editingBlurb = false
      state.profile = cloneDeep(state.beforeEditingState)
      state.beforeEditingState = {}
      state.blurb = cloneDeep(initialState)
      return state
    case set.firstName:
      state.profile.firstName = action.firstName
      state.blurb.isInvalid.firstName = validiateTextField(action.firstName, 63, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.middleName:
      state.profile.middleName = action.middleName
      state.blurb.isInvalid.middleName = validiateTextField(action.middleName, 63, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.lastName:
      state.profile.lastName = action.lastName
      state.blurb.isInvalid.lastName = validiateTextField(action.lastName, 63, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorTitle:
      state.profile.title = action.title
      state.blurb.isInvalid.title = validiateTextField(action.title, 127, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorCompany:
      state.profile.company = action.company
      state.blurb.isInvalid.company = validiateTextField(action.company, 127, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorCompanyWebsite:
      state.profile.companyWebsite = action.website
      state.blurb.isInvalid.companyWebsite = validiateTextField(action.website, 2047, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorBuildingDetails:
      state.profile.buildingDetails = action.buildingDetails
      state.blurb.isInvalid.buildingDetails = validiateTextField(action.buildingDetails, 255, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorStreetAddress:
      state.profile.streetAddress = action.streetAddress
      state.blurb.isInvalid.streetAddress = validiateTextField(action.streetAddress, 255, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorSuburb:
      state.profile.suburb = action.suburb
      state.blurb.isInvalid.suburb = validiateTextField(action.suburb, 255, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorPostalCode:
      state.profile.postalCode = action.postalCode
      state.blurb.isInvalid.postalCode = validiateTextField(action.postalCode, 10, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorCity:
      state.profile.city = action.city
      state.blurb.isInvalid.city = validiateTextField(action.city, 255, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case set.investorDescription:
      state.profile.blurb = action.adviserDescription // todo naming inconsistencies
      state.blurb.isInvalid.businessDescription = validiateTextField(action.adviserDescription, Infinity, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
  }
  return state
}
